module.exports = __webpack_public_path__ + "static/media/Desktop-Banner-Account-Services.3a104aa3.jpg";